// import React from 'react';
// import Services from '../../api/service'
// import { Link } from "react-router-dom";
//
// const ServiceSection = (props) => {
//     const ClickHandler = () => {
//         window.scrollTo(10, 0);
//     }
//
//     return (
//         <section className="service_section section_space xb-hidden pb-0">
//             <div className="container">
//                 <div className="heading_block text-center">
//                     <div className="heading_focus_text">
//                         Our
//                         <span className="badge bg-secondary text-white">Specialize</span>
//                     </div>
//                     <h2 className="heading_text mb-0">
//                         Featured Services
//                     </h2>
//                 </div>
//
//                 <div className="row">
//                     {Services.slice(0, 5).map((service, srv) => (
//                         <div className={`${service.col} mt-30`} key={srv}>
//                             {service.title ?
//                                 <div className="service_block">
//                                     <div className="service_image">
//                                         <img src={service.sImg} alt="IT Management Services" />
//                                     </div>
//                                     <div className="service_content">
//                                         <h3 className="service_title"><Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>{service.title}</Link>
//                                         </h3>
//
//                                         <div className="links_wrapper">
//                                             <ul className="category_btns_group unordered_list">
//                                                 <li><Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>{service.thumb1}</Link></li>
//                                                 <li><Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>{service.thumb2}</Link></li>
//                                             </ul>
//                                             <Link onClick={ClickHandler} to={`/service-single/${service.slug}`} className="icon_block">
//                                                 <i className="fa-regular fa-arrow-up-right"></i>
//                                             </Link>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 : ''}
//                         </div>
//                     ))}
//                 </div>
//
//                 <div className="btns_group pb-0">
//                     <Link onClick={ClickHandler} className="btn btn-outline-light" to="/service">
//                         <span className="btn_label" data-text="More Services">More Services</span>
//                         <span className="btn_icon">
//                             <i className="fa-solid fa-arrow-up-right"></i>
//                         </span>
//                     </Link>
//                 </div>
//             </div>
//         </section>
//     );
// }
//
// export default ServiceSection;



import React from 'react';
import Services from '../../api/service';
import { Link, useNavigate } from "react-router-dom";

const ServiceSection = () => {
    const navigate = useNavigate();

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    const handleCardOnClick = (url) => {
        window.scrollTo(0, 0);
        navigate(url);
    };

    return (
        <section >
            <div className="container">
                {/* Heading */}
                <div className="text-center mb-5">
                    <h2 className="fw-bold text-primary">
                        Our <span className="bg-primary text-white px-2 py-1 rounded">Specialize</span>
                    </h2>
                    <h3 className="mt-3 text-dark">Featured Services</h3>
                </div>

                {/* Services Grid */}
                <div className="row g-4">
                    {Services.map((service, index) => (
                        <div
                            key={index}
                            className="col-12 col-sm-6 col-lg-4"
                            onClick={() => handleCardOnClick(`/service-single/${service.slug}`)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="bg-white rounded shadow-sm h-100 d-flex flex-column justify-content-between service-card transition">
                                <div className="text-center p-4">
                                    <img
                                        src={service.sImg}
                                        alt={service.title}
                                        className="img-fluid"
                                        style={{
                                            width: '60%',  // Ensure the image fills the width of its container
                                            height: '200px', // Fix the height for all images
                                            objectFit: 'fill', // Ensure the images fill the space proportionally
                                        }}
                                    />
                                </div>
                                <div className="text-center px-3 pb-4">
                                    <h5 className="fw-bold mb-3">
                                        <Link to={`/service-single/${service.slug}`} className="text-dark text-decoration-none" onClick={ClickHandler}>
                                            {service.title}
                                        </Link>
                                    </h5>
                                    <ul className="list-unstyled d-flex justify-content-center gap-3 mb-0">
                                        <li>
                                            <Link to={`/service-single/${service.slug}`} onClick={ClickHandler} className="text-primary text-decoration-none fw-semibold">
                                                {service.thumb1}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to={`/service-single/${service.slug}`} onClick={ClickHandler} className="text-primary text-decoration-none fw-semibold">
                                                {service.thumb2}
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>

                {/*/!* Button *!/*/}
                {/*<div className="text-center mt-5">*/}
                {/*    <Link*/}
                {/*        to="/service"*/}
                {/*        onClick={ClickHandler}*/}
                {/*        className="btn btn-outline-primary rounded-pill px-4 py-2 fw-bold"*/}
                {/*    >*/}
                {/*        More Services*/}
                {/*    </Link>*/}
                {/*</div>*/}
            </div>
        </section>
    );
};

export default ServiceSection;
